// Action to -> other user
import { makePaginatedItemsActions } from './items'

export const GET_OTHER_USER_INFO = 'GET_OTHER_USER_INFO'
export const GET_OTHER_USER_INFO_LOADING = 'GET_OTHER_USER_INFO_LOADING'
export const GET_OTHER_USER_INFO_FAILURE = 'GET_OTHER_USER_INFO_FAILURE'
export const GET_OTHER_USER_INFO_SUCCESS = 'GET_OTHER_USER_INFO_SUCCESS'
export const GET_OTHER_USER_INFO_UNLOAD = 'GET_OTHER_USER_INFO_UNLOAD'
export const getOtherUserInfo = idOrUsername => ({
  type: GET_OTHER_USER_INFO,
  payload: idOrUsername,
})
export const unloadOtherUserInfo = () => ({
  type: GET_OTHER_USER_INFO_UNLOAD,
})

export const GET_OTHER_USER_OWNED_ITEMS = 'GET_OTHER_USER_OWNED_ITEMS'
export const [
  loadOwnedItemsOfOtherUser,
  loadMoreOwnedItemsOfOtherUser,
  unloadOwnedItemsOfOtherUser,
  putOwnedItemsOfOtherUserInCache,
] = makePaginatedItemsActions(GET_OTHER_USER_OWNED_ITEMS)

export const GET_OTHER_USER_WANTED_ITEMS = 'GET_OTHER_USER_WANTED_ITEMS'
export const [
  loadWantedItemsOfOtherUser,
  loadMoreWantedItemsOfOtherUser,
  unloadWantedItemsOfOtherUser,
  putWantedItemsOfOtherUserInCache,
] = makePaginatedItemsActions(GET_OTHER_USER_WANTED_ITEMS)

export const GET_OTHER_USER_ITEMS_I_CAN_GET = 'GET_OTHER_USER_ITEMS_I_CAN_GET'
export const [
  loadItemsICanGetFromOtherUser,
  loadMoreItemsICanGetFromOtherUser,
  unloadItemsICanGetFromOtherUser,
  putItemsICantGetFromOtherUserInCache,
] = makePaginatedItemsActions(GET_OTHER_USER_ITEMS_I_CAN_GET)

export const GET_OTHER_USER_ITEMS_I_CAN_GIVE = 'GET_OTHER_USER_ITEMS_I_CAN_GIVE'
export const [
  loadItemsICanGiveToOtherUser,
  loadMoreItemsICanGiveToOtherUser,
  unloadItemsICanGiveToOtherUser,
] = makePaginatedItemsActions(GET_OTHER_USER_ITEMS_I_CAN_GIVE)

export const GET_OTHER_USER_COUNTS = 'GET_OTHER_USER_COUNTS'
export const GET_OTHER_USER_COUNTS_LOADING = 'GET_OTHER_USER_COUNTS_LOADING'
export const GET_OTHER_USER_COUNTS_FAILURE = 'GET_OTHER_USER_COUNTS_FAILURE'
export const GET_OTHER_USER_COUNTS_SUCCESS = 'GET_OTHER_USER_COUNTS_SUCCESS'
export const loadOtherUserCounts = id => ({
  type: GET_OTHER_USER_COUNTS,
  payload: id,
})



// WEBPACK FOOTER //
// ./src/actions/otherUser.js